import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, tap } from 'rxjs';
import { SeqPageTitlesService } from './page-titles.service';

export function getTranslationFiles(): string[] {
    return ['dashboard', 'forms', 'general', 'groups', 'inventory', 'layout', 'orders', 'table'];
}

export function appInitializerFactory(
    translate: TranslateService,
    seqPageTitlesService: SeqPageTitlesService,
    injector: Injector
) {
    return () => {
        seqPageTitlesService;
        return new Promise<any>(resolve => {
            const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
            locationInitialized.then(() => {
                const langToSet = 'en';
                const translationParts = getTranslationFiles();
                translate.setDefaultLang(langToSet);
                translate.use(langToSet).subscribe(
                    () => {
                        forkJoin(
                            translationParts.map(x =>
                                translate.getTranslation('en/' + x).pipe(
                                    tap(translations => {
                                        translate.setTranslation(langToSet, translations, true);
                                    })
                                )
                            )
                        ).subscribe(
                            () => {
                                resolve(null);
                            },
                            _err => {
                                resolve(null);
                            }
                        );
                    },
                    _err => {
                        console.error(`Problem with '${langToSet}' language initialization.`);
                        resolve(null);
                    }
                );
            });
        });
    };
}
